<template>
    <div class="component-list-warpper">
        <h2>Common Components</h2>
        <div class="row">
            <h3>Colors</h3>
            <div class="content row-content">
                <ColorChip color="--red" />
                <ColorChip color="--orange" />
                <ColorChip color="--black1" />
                <ColorChip color="--black2" />
                <ColorChip color="--black3" />
                <ColorChip color="--black4" />
                <ColorChip color="--black5" />

                <ColorChip color="--white" />
                <ColorChip color="--gray1" />
                <ColorChip color="--gray2" />
                <ColorChip color="--border-color1" />
                <ColorChip color="--border-color2" />
                <ColorChip color="--border-color3" />
                <ColorChip color="--border-color4" />
            </div>
        </div>

        <div class="row">
            <h3>Font Style</h3>
            <div class="content row-content">
                <div class="col no-margin">
                    <Sh1>타이틀 1</Sh1>
                    <Sh2>타이틀 2</Sh2>
                    <Sh3>타이틀 3</Sh3>
                    <Sh2 listStyle="dot">타이틀 2 - type2</Sh2>
                    <Sh3 listStyle="dot">타이틀 3 - type2</Sh3>
                </div>
                <div class="col">
                    <Sp1>본문 1</Sp1>
                </div>
            </div>
        </div>

        <div class="row">
            <h3>Buttons</h3>
            <div class="content row-content">
                <RedLineButton :text="`버튼`" />
                <RedLineButton :type="`inbound`" :text="`부가서비스`" />
                <RedLineButton :type="`outbound`" :text="`자료다운로드`" />
                <OrangeLineButton :text="`서비스 신청`" />
            </div>
        </div>

        <h2>Main Page Components</h2>
        <div class="row">
            <div class="content">-</div>
        </div>

        <h2>Sub Page Components</h2>

        <div class="row large">
            <h3>Subpage Title Container</h3>
            <div class="content">
                <SubpageTitleContainer
                    :title="`버튼 영역이 없는 케이스`"
                    :subText="`버튼 영역이 없으면 서브텍스트가 줄바꿈이 없을 시 해당 영역을 가득 채우며 영역을 초과하는 경우 줄바꿈이 발생하게 됩니다. 이때, 줄바꿈이 되는 기준은 띄어쓰기를 기준으로 하는 단어 단위로 개행이 됩니다.`"
                />
                <SubpageTitleContainer
                    :title="`버튼 영역이 존재하는 케이스`"
                    :subText="`
                    버튼 영역이 존재하는 경우 버튼 영역은 서브텍스트 높이의 중앙에 위치하게 됩니다.<br />
                    버튼 영역의 크기는 줄어 들지 않으며 버튼 영역 내 버튼들은 서로서로 10px의 간격을 갖게 되며,<br />
                    서브 텍스트는 버튼 영역을 제외한 나머지 영역을 가득 채울 경우 버튼 영역이 없는 경우와 동일하게 단어 단위로 개행이 됩니다.<br />
                    단, 서브텍스트와 버튼 영역은 20px의 고정 간격을 갖게 됩니다.
                    `"
                >
                    <RedLineButton :type="`inbound`" :text="`부가서비스`" />
                    <RedLineButton :type="`outbound`" :text="`자료다운로드`" />
                </SubpageTitleContainer>
            </div>
        </div>

        <div class="row">
            <h3>Card Box</h3>
            <div class="content row-content">
                <CardBox
                    :idx="1"
                    :title="`기술을 선도하는 기업`"
                    :list="[
                        '국내 최초 신용카드 결제서비스',
                        '국내 최초 신용카드대금 자동이체 서비스',
                        '국내 최초 부산 하나로 교통카드 서비스',
                        '국내 최초 전자서명 서비스',
                        '업계 최초 코스닥 등록',
                    ]"
                >
                </CardBox>

                <CardBox2
                    :title="`EasyCheck IC App`"
                    :list="[
                        '상품 관리 및 상품 결제 가능',
                        '앱카드 결제 가능 (바코드, QR코드 인식 가능)',
                        '포인트 복합 결제 가능',
                        '상품 정보가 서버에 저장되어 인터넷 관리자 프로그램(ASP)과 연동됨',
                    ]"
                >
                </CardBox2>

                <CardBox3 :idx="1" :title="`타이틀`" :content="'서비스 신청을 위해 아래 버튼을 눌러주세요. <br />담당자 확인 후 안내드리겠습니다.'">
                    <OrangeLineButton :text="`서비스 신청`" />
                </CardBox3>
            </div>
        </div>

        <div class="row">
            <h3>Easy Payment Box</h3>
            <div class="content row-content">
                <ImgBorderBox src="npay.png" />
                <ImgBorderBox src="kakaopay.png" />
                <ImgBorderBox src="samsungpay.png" />
                <ImgBorderBox src="applepay.png" />
                <ImgBorderBox src="payco.png" />
                <ImgBorderBox src="tosspay.png" />
            </div>
        </div>

        <div class="row">
            <h3>Image List Item</h3>
            <div class="content row-content">
                <ImageListItem title="카드결제" desc="마그네틱, IC 등 카드 종류와 상관 없이 안전한 결제가 가능합니다." src="sub01_01.png" />
                <ImageListItem
                    title="멤버십 카드 포인트"
                    desc="통신 3사, OK캐쉬백을 포함한 다양한 제휴 멤버십부터 가맹점에서 발급한 자체 포인트까지 이지체크를 통해 편리하게 처리하고 관리할 수 있습니다."
                    src="sub01_02.png"
                />
                <ImageListItem
                    title="영수증 발급"
                    desc="별다른 가입절차 없이 국세청 현금영수증 (소비자소득공제,사업자지출증빙)을 발행할 수 있으며 일반 영수증도 편리하게 출력하실 수 있습니다."
                    src="sub01_03.png"
                />
            </div>
        </div>

        <div class="row">
            <h3>Table Row</h3>
            <div class="content">
                <TableRow
                    :title="`편리한 사용`"
                    :content="`이지체크모바일은 스마트폰 앱 실행시 결제가 가능하며, 배터리 소모를 줄이기 위하여 일정 시간 사용하지 않으면 자동으로 OFF 되어 간편합니다.(ED-944 모델은 휴대폰 연결에 따라 자동으로 ON/OFF)`"
                    :src="`sub01_icon01.png`"
                />
                <TableRow
                    :title="`IC 우선 거래 지원`"
                    :content="`여신 금융 협회에 등록된 보안 인증 단말기로 신용카드 단말기 정보보호 기술 기준에 적합한 제품입니다.`"
                    :src="`sub01_icon02.png`"
                />
                <TableRow
                    :title="`강력한 보안`"
                    :content="`리딩한 카드 정보를 암호화하여 전송하기 때문에 고객의 소중한 정보를 안전하게 보호할 수 있습니다.`"
                    :src="`sub01_icon03.png`"
                />
            </div>
        </div>

        <div class="row">
            <h3>Table Row - 2 grid</h3>
            <div class="content">
                <div class="table-2grid">
                    <TableRow_2grid
                        :title="`출금이체`"
                        :content="`서비스 구독료, 월 이용료 자동이체 등 각종 자금의 대량 수납 및 간편 송금, 계좌 기반 결제 등의 실시간 출금 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                    <TableRow_2grid
                        :title="`입금(지급)이체`"
                        :content="`급여지급, 배당금, 보험료 및 대출금입금, 환불대금 지급 등 각종 자금의 대량 지급 및 간편 송금, 계좌 기반 결제 등의 실시간 입금 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                    <TableRow_2grid
                        :title="`가상계좌`"
                        :content="`하나의 실계좌에 연결된 다수의 가상계좌(입금전용계좌)를 이용기관에 부여하고, 고객님의 납부 및 결제가 필요할 때 가상계좌로 입금 요청하여 입금내역을 실시간으로 확인할 수 있는 서비스 `"
                        :src="`sub01_icon03.png`"
                    />
                    <TableRow_2grid
                        :title="`예금거래내역조회`"
                        :content="`각 은행의 뱅킹 로그인 없이 보유한 계좌의 거래내역을 확인할 수 있는 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <h3>Table Row - 3 grid</h3>
            <div class="content">
                <div class="table-3grid">
                    <TableRow_3grid
                        :title="`예금거래내역조회`"
                        :content="`각 은행의 뱅킹 로그인 없이 보유한 계좌의 거래내역을 확인할 수 있는 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                    <TableRow_3grid
                        :title="`예금거래내역조회`"
                        :content="`각 은행의 뱅킹 로그인 없이 보유한 계좌의 거래내역을 확인할 수 있는 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                    <TableRow_3grid
                        :title="`예금거래내역조회`"
                        :content="`각 은행의 뱅킹 로그인 없이 보유한 계좌의 거래내역을 확인할 수 있는 서비스`"
                        :src="`sub01_icon03.png`"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <h3>Line Box</h3>
            <div class="content">
                <LineBox title="ㅋㅋㅋ">
                    <div class="box">신용카드 결제 서비스</div>
                    <div class="box active">택스리펀드 서비스</div>
                    <div class="box">자국통화(DCC) 서비스</div>
                    <div class="box">해외 간편결제 서비스</div>
                    <div class="box">해외 간편결제 서비스</div>
                    <div class="box">해외 간편결제 서비스</div>
                    <div class="box">해외 간편결제 서비스</div>
                    <div class="box">해외 간편결제 서비스</div>
                </LineBox>
            </div>
        </div>

        <div class="row">
            <h3>Number Row</h3>
            <div class="content">
                <div class="grid-2">
                    <NumberRow idx="01" content="넘버로우 컴포넌트" />
                    <NumberRow idx="02" content="넘버로우 컴포넌트" />
                    <NumberRow idx="03" content="넘버로우 컴포넌트" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ColorChip from '@/components/ColorChip.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import ImgBorderBox from '@/components/ImgBorderBox.vue';
import Sh1 from '@/components/SubTitle1.vue';
import Sh2 from '@/components/SubTitle2.vue';
import Sh3 from '@/components/SubTitle3.vue';
import ImageListItem from '@/components/ImageListItem.vue';
import TableRow from '@/components/TableRow.vue';
import CardBox from '@/components/CardBox.vue';
import CardBox2 from '@/components/CardBox2.vue';
import CardBox3 from '@/components/CardBox3.vue';
import Sp1 from '@/components/SubParagraph1.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import TableRow_3grid from '@/components/TableRow_3grid.vue';
import LineBox from '@/components/LineBox.vue';
import NumberRow from '@/components/NumberRow.vue';

export default {
    components: {
        ColorChip,
        RedLineButton,
        OrangeLineButton,
        SubpageTitleContainer,
        CardBox,
        CardBox2,
        CardBox3,
        ImgBorderBox,
        Sh1,
        Sh2,
        Sh3,
        ImageListItem,
        TableRow,
        Sp1,
        TableRow_2grid,
        TableRow_3grid,
        LineBox,
        NumberRow,
    },
};
</script>

<style lang="scss" scoped>
.component-list-warpper {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-weight: 400;
    font-style: normal;
    padding: 40px 0;

    header {
        position: relative;
    }

    > h1 {
        width: 100%;
        max-width: 1540px;
        font-family: 'Play', sans-serif;
        display: flex;
        font-size: 32px;
        padding: 0;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #ddd;

        .title_logo {
            width: 140px;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 100%;
                max-width: 100%;
            }
        }
    }

    > h2 {
        width: 100%;
        max-width: 1540px;
        font-family: 'Play', sans-serif;
        position: relative;
        font-size: 20px;
        margin: 0;
        padding: 0;
        color: var(--black1);
        margin: 20px 0 0;
        padding-left: 20px;

        &::after {
            content: '';
            position: absolute;
            left: 6px;
            top: 50%;
            transform: translateY(-50%);
            width: 5px;
            height: 5px;
            background: #e61b39;
            border-radius: 100px;
        }
    }

    .row {
        width: 100%;
        max-width: 1540px;
        padding: 20px 0 60px;

        > h3 {
            width: 100%;
            max-width: 1540px;
            font-family: 'Play', sans-serif;
            font-size: 16px;
            margin: 0 auto 20px;
            padding: 0;
            color: var(--black2);
            padding-bottom: 20px;
            font-weight: 600;
            border-bottom: 1px solid #ddd;
        }

        .content {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 20px;

            .col {
                flex: 1 1 0;
                display: flex;
                flex-direction: column;
                gap: 20px;
            }

            &.row-content {
                flex-direction: row;
                flex-wrap: wrap;
            }
        }

        &.large {
            .content {
                gap: 80px;
            }
        }
    }
}

.no-margin {
    h1,
    h2,
    h3,
    h4,
    h5,
    p {
        margin-bottom: 10px !important;
    }
}
</style>
